import { createSlice } from '@reduxjs/toolkit';
import { isStickerStateRevokable } from '@/warehouse/helpers';
import { confirmReceiptItem } from './thunk';
const initialState = {
    crossdockingId: undefined,
    inboxDateRangeFilter: {
        // Should always be `null`, otherwise it fires additional request with this initial values right before the
        // necessary request with values, gotten from local storage.
        dateFrom: null,
        dateTo: null,
    },
    inboxArticleSearchTerm: '',
    inboxItemCount: undefined,
    verificationItemCount: undefined,
    currentItemIndex: -1,
    shouldMoveRowSelectionTo: 0,
    ownerLocation: 'invoice',
    approveReceiptItemDialog: {
        open: false,
        data: undefined,
        availableQuantity: 0,
        isError: false,
        error: undefined,
    },
    revokeReceiptItemDialog: {
        open: false,
        data: undefined,
        markedStickerIds: [],
    },
    blockReceiptItemDialog: {
        open: false,
        data: undefined,
    },
    acceptTrackableReceiptItemDialog: {
        open: false,
        data: undefined,
        isError: false,
        error: undefined,
    },
};
const slice = createSlice({
    name: 'crossdockingReceipt',
    initialState,
    reducers: {
        setCrossdockingId: (state, action) => {
            state.crossdockingId = action.payload;
        },
        setInboxDateRangeFilter: (state, action) => {
            state.inboxDateRangeFilter = action.payload;
        },
        setInboxItemCount: (state, action) => {
            state.inboxItemCount = action.payload;
        },
        setVerificationItemCount: (state, action) => {
            state.verificationItemCount = action.payload;
        },
        setInboxArticleSearchTerm: (state, action) => {
            state.inboxArticleSearchTerm = action.payload;
        },
        setCurrentItemIndex: (state, action) => {
            state.currentItemIndex = action.payload;
        },
        setShouldMoveRowSelectionTo: (state, action) => {
            state.shouldMoveRowSelectionTo = action.payload;
        },
        setOwnerLocation: (state, action) => {
            state.ownerLocation = action.payload;
        },
        openApproveReceiptItemDialog: (state, action) => {
            state.approveReceiptItemDialog = {
                ...state.approveReceiptItemDialog,
                open: true,
                data: {
                    ...action.payload.receiptItemConfirm,
                    isBlocked: false,
                },
                availableQuantity: action.payload.availableQuantity,
            };
        },
        closeApproveReceiptItemDialog: (state) => {
            state.approveReceiptItemDialog = initialState.approveReceiptItemDialog;
        },
        openRevokeReceiptItemDialog: (state, action) => {
            state.revokeReceiptItemDialog.open = true;
            state.revokeReceiptItemDialog.data = action.payload;
        },
        markSticker: (state, action) => {
            const markedIds = state.revokeReceiptItemDialog.markedStickerIds;
            const id = action.payload.stickerId;
            state.revokeReceiptItemDialog.markedStickerIds = markedIds.includes(id)
                ? markedIds.filter((markedId) => markedId !== id)
                : [...markedIds, id];
        },
        markAll: (state, action) => {
            const markedIds = state.revokeReceiptItemDialog.markedStickerIds;
            const revokableStickers = action.payload.stickers.filter((sticker) => isStickerStateRevokable(sticker.state));
            state.revokeReceiptItemDialog.markedStickerIds =
                markedIds.length === revokableStickers.length ? [] : revokableStickers.map((sticker) => sticker.stickerId);
        },
        closeRevokeReceiptItemDialog: (state) => {
            state.revokeReceiptItemDialog = initialState.revokeReceiptItemDialog;
        },
        openBlockReceiptItemDialog: (state, action) => {
            const { receiptItemId, article, brand, invoiceId, name, quantity, receiptedQuantity, blockedQuantity, userName, trackableStatus, } = action.payload;
            // TODO: (later) Nicer to use function like lodash's pick, or:
            // const picked = (({ receiptItemId, article, brand, invoiceId, name, quantity, userName }) => ({
            // 	receiptItemId,
            // 	article,
            // 	brand,
            // 	invoiceId,
            // 	name,
            // 	quantity,
            // 	userName,
            // }))(action.payload);
            state.blockReceiptItemDialog.open = true;
            state.blockReceiptItemDialog.data = {
                receiptItemId,
                article,
                brand,
                invoiceId,
                name,
                availableQuantity: quantity - receiptedQuantity - blockedQuantity,
                userName,
                //  isTrackable,
                isTrackable: Boolean(trackableStatus),
                isBlocked: true,
            };
        },
        closeBlockReceiptItemDialog: (state) => {
            state.blockReceiptItemDialog = initialState.blockReceiptItemDialog;
        },
        openAcceptTrackableReceiptItemDialog: (state, action) => {
            state.acceptTrackableReceiptItemDialog = {
                ...state.acceptTrackableReceiptItemDialog,
                open: true,
                data: action.payload.trackableReceiptItem,
            };
        },
        closeAcceptTrackableReceiptItemDialog: (state) => {
            state.acceptTrackableReceiptItemDialog = initialState.acceptTrackableReceiptItemDialog;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(confirmReceiptItem.rejected, (state, action) => {
            state.approveReceiptItemDialog.isError = true;
            state.approveReceiptItemDialog.error = action.error;
        });
    },
});
export const { actions: crossdockReceiptActions, reducer: crossdockReceiptStateReducer } = slice;
